module.exports = "/_next/static/images/profile-4ca348f95c4517d4d2359ec178186540.svg";